import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { saveCheque } from '../../api/AccountsAPI/chequeBookCreationAPI';

const err = (e, fallback) => e?.Message || e?.message || fallback;

export const submitChequeBook = createAsyncThunk('chequeBookCreation/submit', async (payload, { rejectWithValue }) => {
    try {
        const res = await saveCheque(payload);
        const status = res?.Data;
        if (status !== 'Successfull' && status !== 'Successful') return rejectWithValue(status || 'Failed to save cheque book');
        return status;
    } catch (e) { return rejectWithValue(err(e, 'Failed to save cheque book')); }
});

const initialState = {
    saveLoading: false, saveResult: null, saveError: null,
};

const chequeBookCreationSlice = createSlice({
    name: 'chequeBookCreation',
    initialState,
    reducers: {
        clearSaveResult: (s) => { s.saveResult = null; s.saveError = null; },
        resetChequeBookCreation: () => initialState,
    },
    extraReducers: (builder) => {
        builder
            .addCase(submitChequeBook.pending, (s) => { s.saveLoading = true; s.saveError = null; s.saveResult = null; })
            .addCase(submitChequeBook.fulfilled, (s, a) => { s.saveLoading = false; s.saveResult = a.payload; })
            .addCase(submitChequeBook.rejected, (s, a) => { s.saveLoading = false; s.saveError = a.payload; });
    },
});

export const { clearSaveResult, resetChequeBookCreation } = chequeBookCreationSlice.actions;

export const selectChequeBookCreation = (s) => s.chequeBookCreation;

export default chequeBookCreationSlice.reducer;
